import { auth } from '../firebaseconfig';
import { updatePassword, reauthenticateWithCredential, EmailAuthProvider } from 'firebase/auth';

export const changeUserPassword = async (currentPassword, newPassword) => {
  try {
    const user = auth.currentUser;
    if (!user) {
      throw new Error('No hay usuario autenticado');
    }

    // Primero, reautenticamos al usuario
    const credential = EmailAuthProvider.credential(user.email, currentPassword);
    await reauthenticateWithCredential(user, credential);

    // Luego, actualizamos la contraseña
    await updatePassword(user, newPassword);
    
    return { success: true, message: 'Contraseña actualizada exitosamente' };
  } catch (error) {
    console.error('Error al actualizar contraseña:', error);

    if (error.code === 'auth/wrong-password') {
      return { 
        success: false, 
        message: 'La contraseña actual es incorrecta'
      };
    }

    if (error.code === 'auth/weak-password') {
      return { 
        success: false, 
        message: 'La nueva contraseña es demasiado débil. Debe tener al menos 6 caracteres.'
      };
    }

    return { 
      success: false, 
      message: 'Contraseña actual incorrecta. Por favor, inténtelo de nuevo.'
    };
  }
};

